const BASE = '/assets/roammyway/cinematic'

/**
 * The cinematic journey, in three beats: DREAM → GO → ARRIVE.
 *
 * The longer five-beat arc (adding PLAN after DREAM, and DISCOVER / EXPERIENCE
 * before ARRIVE) is still available — the placeholder painters for those scenes
 * live in scripts/generate-placeholders.mjs. To re-expand, add the scene entries
 * back here, add their ids to SCENE_SEQUENCE in that script, and add one more
 * `connectors` slot per new scene.
 *
 * Posters ship with the repo and are what you see today. The scrubbed clips are
 * not produced yet — when they are, drop them at
 *   {BASE}/scene-0N/clip.mp4        (landscape master, crf ~20, -g 8, +faststart, no audio)
 *   {BASE}/scene-0N/clip-mobile.mp4 (~720p, -g 4, for phone decoders)
 *   {BASE}/connector-0N/clip.mp4    (seam endpoints must be the neighbouring clips'
 *                                    actual rendered frames, or the seam pops)
 * and set the `clip` / `clipMobile` fields below. Nothing else changes — the
 * engine reads this config and the posters become the loading state.
 *
 * Shape documented by the `CinematicConfig` typedef in ../lib/scrollWorld.
 */
export const cinematicConfig = {
  sceneScroll: 1.4,
  connectorScroll: 0.9,
  crossfade: 0.14,
  scenes: [
    {
      id: 'dream',
      number: '01',
      title: 'Dream',
      overlay: ['The trip you keep', 'putting off.'],
      description: 'Every roam starts with picking a day and finally committing to it.',
      poster: `${BASE}/scene-01/poster.jpg`,
      posterMobile: `${BASE}/scene-01/poster-mobile.jpg`,
      scroll: 1.5,
      linger: 0.35,
    },
    {
      id: 'go',
      number: '02',
      title: 'Go',
      overlay: ['Bags packed.', 'Plan locked in.'],
      description: 'Flights booked, stays confirmed, route mapped — nothing left but to leave.',
      poster: `${BASE}/scene-02/poster.jpg`,
      posterMobile: `${BASE}/scene-02/poster-mobile.jpg`,
      scroll: 1.5,
      linger: 0.4,
    },
    {
      id: 'arrive',
      number: '03',
      title: 'Arrive',
      overlay: ['Where will', 'you roam next?'],
      description: "You're barely home before the next itinerary starts taking shape.",
      poster: `${BASE}/scene-03/poster.jpg`,
      posterMobile: `${BASE}/scene-03/poster-mobile.jpg`,
      scroll: 1.5,
      linger: 0.3,
    },
  ],
  // One fewer than the scenes. `null` = the two scenes cross-dissolve.
  connectors: [{ clip: null }, { clip: null }],
}
